import {JsToClientCommand} from '../jsToClientCommand';
import {ClientCommands} from '../clientCommands';
import { GameStartShortData } from '../../types/client';


export class SetStartShortDataCommand extends JsToClientCommand<Partial<GameStartShortData>> {
    constructor(params: Partial<GameStartShortData>) {
        super(ClientCommands.SET_START_SHORT_DATA, params);
    }
}
